export default __webpack_public_path__ + "static/media/logo.1173760e.svg";